__turbopack_context__.v({
  "container": "UpdateScreen-module-scss-module__X3ymCa__container",
  "image": "UpdateScreen-module-scss-module__X3ymCa__image",
  "legal": "UpdateScreen-module-scss-module__X3ymCa__legal",
  "logotype": "UpdateScreen-module-scss-module__X3ymCa__logotype",
  "subtitle": "UpdateScreen-module-scss-module__X3ymCa__subtitle",
  "title": "UpdateScreen-module-scss-module__X3ymCa__title",
  "updateButton": "UpdateScreen-module-scss-module__X3ymCa__updateButton",
  "versionDetails": "UpdateScreen-module-scss-module__X3ymCa__versionDetails",
});
